import { Button, Divider } from "@blueprintjs/core"
import { HasId, ID } from "src/libs/interfaces/layouts"
import { __ } from "src/libs/utilities"
import { HISTORY_TYPE, IHistoryStep, ILandingSection, SECTION_DESIGN_TYPE } from "src/modules/pe-landing-module/data/interfaces"
import { ILandingStore, useLandingStore } from "src/modules/pe-landing-module/data/store"
import { useComposition } from "src/modules/pe-landing-module/hooks/useComposition"
import updateHistory from "./utils/updateHistory"

/* Protopia Ecosystem component */
export interface IColumnWidgetProps {
   sectionId: ID
   dataId: ID
   id: ID
}
const ColumnCardWidget = ({sectionId, dataId, ...props}: IColumnWidgetProps): JSX.Element => {
    const currentLanding    = useLandingStore((state: ILandingStore) => state.currentLanding)
    const section           = currentLanding.sections.find( (section: HasId) => section.id === sectionId ) 
    const meat              = section.data.find((meat: HasId) => meat.id === dataId)
    const composition       = useComposition(section)
    const onCount = (counts: number) => {
        const prevData          = JSON.parse( JSON.stringify( section ) )
        const newSection: any   = { 
            ...section, 
            data: section.data.map((m: any) => {
                if(m.id === dataId) {
                    return {
                        ...m,
                        columns: counts
                    }
                }
                return m
            })
        } 
        const historyStep: IHistoryStep = {
            data:  newSection,
            prevData,
            type: HISTORY_TYPE.SECTION,
            title : "Change cards columns",
        }
        const newLanding = {
            ...currentLanding,
            sections: currentLanding.sections.map((sec: ILandingSection) => {
                if(sec.id === sectionId ) {
                    return newSection
                }
                return sec
            })
        }  
        updateHistory( historyStep, newLanding ) 
    }
    const onAdd = () => {
        if(meat.columns < 12) {
            onCount( meat.columns + 1)
        }
    }
    const onRemove = () => {
        if(meat.columns > 1 ) {
            onCount( meat.columns - 1)
        }
    }
    return [ SECTION_DESIGN_TYPE.FEED, SECTION_DESIGN_TYPE.CAROUSEL, SECTION_DESIGN_TYPE.CAROUSEL, SECTION_DESIGN_TYPE.COLUMN, ].includes( meat.feedType ) || typeof meat.feedType === "undefined"
        ?
        <>
            <div className="p-2 "> 
                <div className="d-flex align-items-center w-100">
                    { __( "Columns" ) }: 
                    <span className="title ml-2 text-wrap mr-auto">{ meat.columns }</span>
                    <Button variant="minimal" size="small" icon="chevron-up" disabled={ meat.columns > 11 } onClick={onAdd} /> 
                    <Button variant="minimal" size="small" icon="chevron-down"  disabled={ meat.columns < 2 } onClick={onRemove}/>
                </div> 
            </div> 
            <Divider />
        </>
        :
        <></>
}
export default ColumnCardWidget